const CACHED_PATH = '/cached/';

export { CACHED_PATH };
